export const enUS = {
    values: {
        'Choose a dashboard to link': 'Choose a dashboard to link',
        'Search by dashboard name': 'Search by dashboard name',
        'Filter by perspective': 'Filter by perspective',
        'Clear search': 'Clear search',
        'DASHBOARD NAME': 'DASHBOARD NAME',
        'LAST CHANGE': 'LAST CHANGE',
        'Error loading dashboards': 'Error loading dashboards',
        Loading: 'Loading',
        'All visible dashboards are already linked': 'All visible dashboards are already linked',
        Retry: 'Retry',
        'No dashboards found': 'No dashboards found'
    }
}
